import React from 'react';
import Header from 'components/organisms/Header/HomeHeader';
import Footer from 'components/organisms/Footer/GlobalFooter';
import { Box, Typography } from '@mui/material';

const Redirect = () => {
  const logo = require('assets/logo.png');
  return (
    <>
      <Header />
      <Box
        sx={{
          height: '100vh',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <Typography
          sx={{
            color: 'white',
            fontWeight: 600,
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
          }}
          component={'h1'}
          variant="h2"
        >
          Welcome To{' '}
          <span style={{ color: '#DDB930' }}>
            {' '}
            <img
              src={logo}
              alt="icon"
              style={{
                // minHeight: "150px",
                // minWidth: "100px",
                maxWidth: '185px',
                width: '100%',
                marginTop: 10,
              }}
            />
          </span>
        </Typography>
        <Typography
          sx={{ fontStyle: 'italic', fontWeight: 300 }}
          component={'p'}
          variant="body1"
        >
          You will be redirected in a moment.
        </Typography>
      </Box>
      <Footer />
    </>
  );
};

export default Redirect;
